// extracted by mini-css-extract-plugin
module.exports = {"item":"item___3D0Ms","is-expanded":"is-expanded___1jQku","name":"name___1yEtv","feature":"feature___bEKfK"};